/**
 * 性能相关的mixin
 */

export default {
    data() {
        return {
            fromIndex: true
        };
    },
    beforeRouteEnter(to, from, next) {
        next(vm => {
            if (from && from.name) {
                vm.fromIndex = false;
            }
        });
    }
};
